module.exports = __webpack_public_path__ + "static/media/cinema.54117c7c.jpg";